import React from 'react';
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

const OccurrencePhones = ({data, type}) => {
    const phones = data.phones ?? []
    if (!phones.length || !phones) return null;

    const socialInfo = [
        {
            label: "Rede social",
            value: data?.socialNetwork ?? ""
        }
    ];

    return (
        <>
            { phones && (
                <section className="space-y-4!">
                    <div className={`text-[16px] font-semibold text-[#4F4F4F] mb-2 print:break-after-avoid!`}>
                        { type === 'individual' ? "Contatos" : "Telefones" }
                    </div>

                    { phones.map((item, index) => {

                        const info = [
                            {
                                label: "Tipo",
                                value: item?.type ?? "",
                            },
                            {
                                label: "Número",
                                value: item?.data ?? "",
                                span: type === 'individual' ? 2 : ''
                            }
                        ];

                        return (
                            <>
                                <InfoGrid key={`${index}`} title={""} items={info} columns={type === 'individual' ? 3 : 2} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}

                    <InfoGrid title={""} items={socialInfo} columns={1} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'px-0!'}/>
                </section>
            )}
        </>
    );
};

export default OccurrencePhones;